/**
 * @file 学员管理页
 * @description 侧栏「学员管理」对应页面：列表与新增。
 *
 * @whenToUse 路由 `/students`。
 * @whenNotToUse 其他业务菜单页。
 */

import { StudentPanel } from '@/components/pages/student-page/student-panel.tsx'

export function StudentPage() {
  return <StudentPanel />
}
